import { t } from '@lingui/core/macro';
import { QuoteStatus, TireQuoteRecordCustomer, TireQuoteRecordList } from '@navio/nsdk';
import { TireOfferMinimal } from 'noddi-types';
import { NoddiBadge } from 'noddi-ui-web';
import { shouldPayForOrder } from '../../utils/tireOfferPayment';

function getTranslatedQuoteStatus(status: QuoteStatus | string) {
  switch (status) {
    case QuoteStatus.ACCEPTED:
      return t`Processing`;
    case QuoteStatus.INVENTORY_ORDERED_AT_SUPPLIERS_IN_FULL:
    case QuoteStatus.INVENTORY_ORDERED_AT_SUPPLIERS_PARTIAL:
      return t`Tires ordered`;
    case QuoteStatus.INVENTORY_RECEIVED_IN_FULL:
    case QuoteStatus.INVENTORY_RECEIVED_PARTIAL:
      return t`Tires arrived`;
    case QuoteStatus.TIRES_MOUNTED_ON_WHEELS_AT_STORAGE_FACILITY:
    case QuoteStatus.TIRES_MOUNTED_ON_WHEELS_AT_CUSTOMER:
      return t`Tires mounted`;
    case QuoteStatus.FULFILLED:
    case QuoteStatus.FULFILLED_PARTIALLY:
      return t`Completed`;
    default:
      return null;
  }
}

interface TireOfferStatusChipProps {
  tireOffer: TireOfferMinimal | TireQuoteRecordList | TireQuoteRecordCustomer;
}

export const TireOfferStatusChip = ({ tireOffer }: TireOfferStatusChipProps) => {
  const orderAcceptedButShouldPay = shouldPayForOrder({
    isPaid: tireOffer.isPaid,
    paymentMethodInTireOffer: tireOffer.paymentMethod,
    isSelected: tireOffer.isSelected
  });

  const status =
    'status' in tireOffer && typeof tireOffer.status === 'object' && tireOffer.status !== null
      ? (tireOffer.status as { status?: string | QuoteStatus }).status
      : (tireOffer as TireOfferMinimal).status.status;

  return orderAcceptedButShouldPay ? (
    <NoddiBadge variant='warning' className='w-fit'>
      {t`Unpaid`}
    </NoddiBadge>
  ) : status && getTranslatedQuoteStatus(status) ? (
    <NoddiBadge variant='outline' className='w-fit'>
      {getTranslatedQuoteStatus(status)}
    </NoddiBadge>
  ) : null;
};
